import produce from "immer"
import { TEXT } from "const"
import { CcLibraryItem } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initCcLibraryItem: CcLibraryItem = {
    id: null,
    headingId: null,
    itemId: null,
    librarySetId: null,
    accountId: null,
    projectId: null,
    publicId: "",
    compliantItem: "",
    interpretation: "",
    original: "",
    note: "",
    creator: null,
    answerType: TEXT,
    options: "",
    order: 0,
    group: null,
}

const initCcLibraryItemState: types.CcLibraryItemState = {
    itemList: {},
    itemGroupedIds: null,
    itemView: initCcLibraryItem,
    itemEdit: initCcLibraryItem,

    reloadList: true,
    reloadView: true,
    reloadEdit: true,

    parentItemId: null,
    parentHeadingId: null,

    availableParents: [],
    availableParentsFiltered: [],
    availableParentSearch: "",

    confirmDelete: null,

    menuTargetId: null,
    menuTargetElement: null,
}

const ccLibraryItemReducer = produce((
    draft: types.CcLibraryItemState = initCcLibraryItemState,
    action: ActionTypes = null,
): types.CcLibraryItemState => {
    switch (action.type) {
        case types.CC_LIBRARY_ITEM_LIST:
            draft.itemList = action.itemList
            return draft

        case types.CC_LIBRARY_ITEM_NESTED:
            draft.itemGroupedIds = action.itemGroupedIds
            return draft

        case types.CC_LIBRARY_ITEM_VIEW:
            draft.itemView = action.item
            return draft

        case types.CC_LIBRARY_ITEM_EDIT:
            draft.itemEdit = action.item
            return draft

        case types.CC_LIBRARY_ITEM_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.CC_LIBRARY_ITEM_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.CC_LIBRARY_ITEM_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        case types.CC_LIBRARY_ITEM_PARENTS:
            draft.parentItemId = action.parentItemId
            draft.parentHeadingId = action.parentHeadingId
            return draft

        case types.CC_LIBRARY_ITEM_AVAILABLE_PARENTS:
            draft.availableParents = action.parents
            return draft

        case types.CC_LIBRARY_ITEM_AVAILABLE_PARENTS_FILTERED:
            draft.availableParentsFiltered = action.parentsFiltered
            return draft

        case types.CC_LIBRARY_ITEM_AVAILABLE_PARENT_SEARCH:
            draft.availableParentSearch = action.search
            return draft

        case types.CC_LIBRARY_ITEM_MENU:
            draft.menuTargetId = action.targetId
            draft.menuTargetElement = action.targetElement
            return draft

        case types.CC_LIBRARY_ITEM_CONFIRM_DELETE:
            draft.confirmDelete = action.item
            return draft

        default:
            return draft
    }
})
export default ccLibraryItemReducer
